

























import { Component, Vue, Prop, Model, Watch } from "@/common";

@Component({})
export default class TwWindow extends Vue {
  @Model("change")
  private value: boolean;

  @Prop({ default: true })
  private showClose: boolean;

  @Prop({ default: true })
  private showFooter: boolean;

  @Prop({ default: false })
  private center: boolean;

  @Prop({ default: false })
  private fullscreen: boolean;

  @Prop({ default: "600px" })
  private width: string;

  @Prop({ default: "15vh" })
  private top: string;

  @Prop({})
  private title: string;

  @Prop({})
  private beforeClose: Function; //右上角关闭按钮或者esc触发

  @Prop({ default: false })
  private loading: boolean;

  private visible: boolean = false;

  @Watch("value")
  private changeShow(val) {
    this.visible = val;
  }

  private cancel() {
    this.closeDialog();
    this.$emit("on-cancel");
  }

  private ok() {
    this.$emit("on-ok");
  }

  private open(){
    this.$emit("open");
  }

  private close(done) {
    if (this.beforeClose) {
      this.beforeClose(done);
    } else {
      this.closeDialog();
    }
  }
  private closeDialog() {
    this.$emit("change", false);
  }

  mounted() {
    this.visible = this.value;
  }
}
